import { render, staticRenderFns } from "./AddressManagement.vue?vue&type=template&id=6acbb587&scoped=true&"
import script from "./AddressManagement.vue?vue&type=script&lang=js&"
export * from "./AddressManagement.vue?vue&type=script&lang=js&"
import style0 from "./AddressManagement.vue?vue&type=style&index=0&id=6acbb587&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acbb587",
  null
  
)

export default component.exports